import * as React from 'react';

import { withTranslation, Link } from '@i18n';
import { TREATMENT_COST_FLOW } from '@routes';
import {
  StyledCoverMaxWidthWrapper,
  StyledHeading,
  StyledFlowCards,
  StyledCard,
  StyledContent,
  StyledCount,
  StyledSubText,
  StyledText,
  StyledImage,
  StyledCardImages,
  StyledGetStarted,
  StyledMobileCard
} from './styles';

const TPFFlow = ({ t, Mobile }) => (
  <StyledCoverMaxWidthWrapper>
    <StyledHeading>
      {t('TPFFlow.Heading')}
    </StyledHeading>
    <StyledFlowCards>
      <StyledCard>
        <StyledContent>
          <StyledCount src="../../../static/images/HowItWorks/01.svg" alt="" />
          <StyledText>
            {t('TPFFlow.Card1Heading')}
          </StyledText>
          {!Mobile
          && (
          <StyledSubText>
            {t('TPFFlow.Card1SubHeading')}
          </StyledSubText>
          )}
        </StyledContent>
        <StyledCardImages>
          <StyledImage
            first
            src={Mobile
              ? '../../../static/images/HowItWorks/MobileCard1Img1.webp'
              : '../../../static/images/HowItWorks/Card1Img1.webp'}
            alt=""
          />
          <StyledImage
            src={Mobile
              ? '../../../static/images/HowItWorks/MobileCard1Img2.webp'
              : '../../../static/images/HowItWorks/Card1Img2.webp'}
            alt=""
          />
        </StyledCardImages>
        {Mobile
          && (
          <StyledSubText>
            {t('TPFFlow.Card1SubHeading')}
          </StyledSubText>
          )}
      </StyledCard>

      <StyledCard>
        <StyledContent>
          <StyledCount src="../../../static/images/HowItWorks/02.svg" alt="" />
          <StyledText>
            {t('TPFFlow.Card2Heading')}
          </StyledText>
          {!Mobile
          && (
          <StyledSubText>
            {t('TPFFlow.Card2SubHeading')}
          </StyledSubText>
          )}
        </StyledContent>
        {!Mobile
          && (
          <StyledCardImages>
            <StyledImage
              first
              src={Mobile
                ? '../../../static/images/HowItWorks/MobileCard2Img1.webp'
                : '../../../static/images/HowItWorks/Card2Img1.webp'}
              alt=""
            />
            <StyledImage
              first
              doctorCard
              src="../../../static/images/HowItWorks/Card2Img2.webp"
              alt=""
            />
            <StyledImage
              doctorCard
              src="../../../static/images/HowItWorks/Card2Img3.webp"
              alt=""
            />
          </StyledCardImages>
          )}
        {Mobile
          && (
            <>
              <StyledCardImages>
                <StyledImage
                  first
                  src={Mobile
                    ? '../../../static/images/HowItWorks/MobileCard2Img1.webp'
                    : '../../../static/images/HowItWorks/Card2Img1.webp'}
                  alt=""
                />
                <StyledMobileCard>
                  <StyledImage
                    first
                    doctorCard
                    src="../../../static/images/HowItWorks/Card2Img2.webp"
                    alt=""
                  />
                  <StyledImage first doctorCard src="../../../static/images/HowItWorks/Card2Img3.webp" alt="" />
                  <StyledImage doctorCard src="../../../static/images/HowItWorks/Card2Img3.webp" alt="" />
                </StyledMobileCard>
              </StyledCardImages>
              <StyledSubText>
                {t('TPFFlow.Card2SubHeading')}
              </StyledSubText>
            </>
          )}
      </StyledCard>
    </StyledFlowCards>
    <StyledFlowCards>
      <StyledCard>
        <StyledContent>
          <StyledCount src="../../../static/images/HowItWorks/03.svg" alt="" />
          <StyledText>
            {t('TPFFlow.Card3Heading')}
          </StyledText>
          {!Mobile
          && (
          <StyledSubText>
            {t('TPFFlow.Card3SubHeading')}
          </StyledSubText>
          )}
        </StyledContent>
        <StyledCardImages>
          <StyledImage
            first
            src={Mobile
              ? '../../../static/images/HowItWorks/MobileCard3Img1.webp'
              : '../../../static/images/HowItWorks/Card3Img1.webp'}
            alt=""
          />
          <StyledImage
            first
            src={Mobile
              ? '../../../static/images/HowItWorks/MobileCard3Img2.webp'
              : '../../../static/images/HowItWorks/Card3Img2.webp'}
            alt=""
          />
        </StyledCardImages>
        {Mobile
          && (
          <StyledSubText>
            {t('TPFFlow.Card3SubHeading')}
          </StyledSubText>
          )}
      </StyledCard>

      <StyledCard last>
        <StyledContent>
          <StyledCount src="../../../static/images/HowItWorks/04.svg" alt="" />
          <StyledText last>
            {t('TPFFlow.Card4Heading')}
          </StyledText>
          {!Mobile
          && (
            <>
              <StyledSubText>
                {t('TPFFlow.Card4SubHeading')}
              </StyledSubText>
              <Link href={TREATMENT_COST_FLOW} params={{ path: 'name' }} passHref>
                <StyledGetStarted>
                  {t('TPFFlow.GetStarted')}
                </StyledGetStarted>
              </Link>
            </>
          )}

        </StyledContent>
        <StyledCardImages>
          <StyledImage
            first
            src={Mobile
              ? '../../../static/images/HowItWorks/MobileCard4Img1.webp'
              : '../../../static/images/HowItWorks/Card4Img1.webp'}
            alt=""
          />
          <StyledImage
            src={Mobile
              ? '../../../static/images/HowItWorks/MobileCard4Img2.webp'
              : '../../../static/images/HowItWorks/Card4Img2.webp'}
            alt=""
          />
        </StyledCardImages>
        {Mobile
          && (
            <>
              <Link href={TREATMENT_COST_FLOW} params={{ path: 'name' }} passHref>
                <StyledGetStarted>
                  {t('TPFFlow.GetStarted')}
                </StyledGetStarted>
              </Link>
              <StyledSubText>
                {t('TPFFlow.Card4SubHeading')}
              </StyledSubText>
            </>
          )}
      </StyledCard>
    </StyledFlowCards>

  </StyledCoverMaxWidthWrapper>
);

TPFFlow.getInitialProps = () => ({
  namespacesRequired: ['HowItWorksScreen']
});

export default withTranslation('HowItWorksScreen')(TPFFlow);
